import HttpClient from "./api";

class ReportApi extends HttpClient {
    public constructor() {
        super();
    }

    getVariablesReport(datesFilter: string, brandsFilter: string, search: string) {
        const query = search ? `search=` + encodeURIComponent(search) : "";
        return this.doGet(`/api/v3/reports/variables?${datesFilter}&${brandsFilter}&${query}`)
    }

    getSecondVariablesReport(datesFilter: string, brandsFilter: string, search: string) {
        const query = search ? `search=` + encodeURIComponent(search) : "";
        return this.doGet(`/api/v3/reports/second/variables?${datesFilter}&${brandsFilter}&${query}`)
    }

    getMonthlyVariablesReport(datesFilter: string, brandsFilter: string, search: string) {
        const query = search ? `search=` + encodeURIComponent(search) : "";
        return this.doGet(`/api/v3/reports/monthly/variables?${datesFilter}&${brandsFilter}&${query}`)
    }
}

export const reportApi = new ReportApi();